/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

@mixin hyphenation {
  hyphens: auto;
  /*toDo:
  when support for hyphenation configuration grows, still clarify configuration with designers */
  hyphenate-limit-chars: 10 3 2;
}

:host {
  color: v(fontColor);
  transition: color $transition-duration ease-in-out;
}

.#{$prefix}heading-brand {
  @include eon-typography("h1-brand");

  &.#{$prefix}hyphenation {
    @include hyphenation;
  }

  &.#{$prefix}right {
    text-align: right;
  }

  &.#{$prefix}left {
    text-align: left;
  }

  &.#{$prefix}center {
    text-align: center;
  }

  &.#{$prefix}ignore-alignment {
    text-align: unset;
  }
}

:host(.container-breakpoint-1200) {
  .#{$prefix}container-based-size {
    &.#{$prefix}heading-brand {
      font-size: $heading-h1-brand-font-size-desktop;
      line-height: $heading-h1-brand-line-height-desktop;
    }
  }
}

:host(.container-breakpoint-800) {
  .#{$prefix}container-based-size {
    &.#{$prefix}heading-brand {
      font-size: $heading-h1-brand-font-size-tablet;
      line-height: $heading-h1-brand-line-height-tablet;
    }
  }
}

:host(.container-breakpoint-400) {
  .#{$prefix}container-based-size {
    &.#{$prefix}heading-h1 {
      font-size: $heading-h1-brand-font-size-phone;
      line-height: $heading-h1-brand-line-height-phone;
    }
  }
}
